import { Alternative } from "src/helpers/types";
import TimeLabel from "./TimeLabel";
import { LanguageContext } from "../languageContext";
import { useContext } from "react";
import { TypographyP } from "../Typography";
import { TextId } from "src/Translations";
export default function TravelTimeExplanation({
  alternative,
  hours,
  minutes,
  seconds,
  stringKey,
}: {
  alternative: Alternative;
  hours: number;
  minutes: number;
  seconds: number;
  stringKey: string;
}) {
  const { translate } = useContext(LanguageContext);
  return (
    <div className="space-y-4 p-4">
      <div className="flex space-x-4 items-center">
        <strong>{translate("time")}</strong>
        <TimeLabel hours={hours} minutes={minutes} seconds={seconds} />
      </div>
      <div className="space-y-1">
        <TypographyP className="font-bold" textId="explanation" />
        <TypographyP textId={`${stringKey}-${alternative}` as TextId} />
      </div>
    </div>
  );
}
